var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_975_312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2021 13.9496H4.50295C4.06199 13.9496 3.70459 13.5922 3.70459 13.1513C3.70459 12.7103 4.06199 12.3529 4.50295 12.3529H15.2018C15.6428 12.3529 16.0002 12.7103 16.0002 13.1513C16.0002 13.5922 15.643 13.9496 15.2021 13.9496Z",
    fill: "#2487FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2021 8.93828H4.50295C4.06199 8.93828 3.70459 8.58088 3.70459 8.13992C3.70459 7.69895 4.06199 7.34155 4.50295 7.34155H15.2018C15.6428 7.34155 16.0002 7.69895 16.0002 8.13992C16.0004 8.58088 15.643 8.93828 15.2021 8.93828Z",
    fill: "#2487FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2021 3.92693H4.50295C4.06199 3.92693 3.70459 3.56953 3.70459 3.12856C3.70459 2.6876 4.06199 2.3302 4.50295 2.3302H15.2018C15.6428 2.3302 16.0002 2.6876 16.0002 3.12856C16.0002 3.56953 15.643 3.92693 15.2021 3.92693Z",
    fill: "#2487FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0722 4.26257C1.66436 4.26257 2.1444 3.78253 2.1444 3.19037C2.1444 2.59821 1.66436 2.11816 1.0722 2.11816C0.48004 2.11816 0 2.59821 0 3.19037C0 3.78253 0.48004 4.26257 1.0722 4.26257Z",
    fill: "#2487FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0722 9.21215C1.66436 9.21215 2.1444 8.73211 2.1444 8.13995C2.1444 7.54779 1.66436 7.06775 1.0722 7.06775C0.48004 7.06775 0 7.54779 0 8.13995C0 8.73211 0.48004 9.21215 1.0722 9.21215Z",
    fill: "#2487FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0722 14.1617C1.66436 14.1617 2.1444 13.6817 2.1444 13.0895C2.1444 12.4974 1.66436 12.0173 1.0722 12.0173C0.48004 12.0173 0 12.4974 0 13.0895C0 13.6817 0.48004 14.1617 1.0722 14.1617Z",
    fill: "#2487FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_975_312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/list-icon.50d56b46f3a16461a9bd2d56c8b0e458.svg";
export { ForwardRef as ReactComponent };